import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type PlayerInfoSlice = {
  token?: string
  tokenTimestamp?: number
}

const initialState: PlayerInfoSlice = {
  token: ''
}

const slice = createSlice({
  name: 'playerInfo',
  initialState: initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
    },
    setTokenTimestamp: (state, action: PayloadAction<number>) => {
      state.tokenTimestamp = action.payload
    }
  }
})

export const reducer = slice.reducer
export const actions = slice.actions
